import {closeCurrentDialog, openDialog, showNotification} from 'platform/components';

import {isEmpty, isNil} from 'ramda';

import i18n from '@dms/i18n';
import {DmsDataGrid, SentMessagePreviewDialog} from '@dms/shared';

import {EMPTY_PLACEHOLDER, valueOrPlaceholder} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

const PREDEFINED_COLUMNS = ['content', 'from', 'to', 'subject', 'receivedAt'] as const;

export function SyncedMessagesDatagrid() {
  const actionCallback: ActionCallback<typeof PREDEFINED_COLUMNS> = ({
    actionKey,
    getColumnData,
  }) => {
    if (actionKey !== 'preview') {
      return;
    }

    const content = getColumnData<string>('content')?.value;

    if (isNil(content) || isEmpty(content)) {
      showNotification.error();
      return;
    }

    const from = getColumnData<string[]>('from')?.value;
    const to = getColumnData<string[]>('to')?.value;
    const subject = getColumnData<string>('subject')?.value;
    const receivedAt = getColumnData<string>('receivedAt')?.value;

    openDialog(
      <SentMessagePreviewDialog
        body={valueOrPlaceholder(content)}
        recipient={firstOrPlaceholder(to)}
        sender={firstOrPlaceholder(from)}
        sentAt={valueOrPlaceholder(receivedAt)}
        subject={subject && !isEmpty(subject) ? subject : EMPTY_PLACEHOLDER}
      />,
      {
        title: i18n.t('entity.email.labels.sentEmail'),
        size: 'large',
        buttons: [
          {
            title: i18n.t('general.actions.close'),
            onClick: closeCurrentDialog,
            variant: 'secondary',
          },
        ],
      }
    );
  };

  return (
    <DmsDataGrid
      autoHeight
      gridCode="messaging-synced-message"
      actionCallback={actionCallback}
      predefinedColumns={PREDEFINED_COLUMNS}
      data-testid="my-profile-emailSynchronization-syncedMessages-datagrid"
    />
  );
}

function firstOrPlaceholder(values: (string | undefined)[] | undefined): string {
  const first = values?.[0];
  return isNil(first) ? EMPTY_PLACEHOLDER : first;
}
